module.exports = {
      id: "logos:nswvolunteering-usage",
      viewBox: "0 0 217 16",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#logos:nswvolunteering-usage",
      toString: function () {
        return this.url;
      }
    }